import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Cookies from "universal-cookie";
const BaseUrl = process.env.REACT_APP_BASE_URL;

const Register = () => {


  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    password: "",
    password_confirmation: "",
    phone_number: "",
    country_id: "",
    package_id: "",
    logo: "",
    profile_image: "",
    business_name: "",
    business_name_ar: "",
  });
  const package_id = searchParams.get('package_id');
  const [countries, setCountries] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const cookies = new Cookies();
  React.useEffect(() => {
    const token = cookies.get("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  useEffect(() => {
    fetch(`${BaseUrl}countries`)
      .then((res) => res.json())
      .then((data) => setCountries(data.data))
      .catch(() => setCountries([]));
  }, []);

  useEffect(() => {
    fetch(`${BaseUrl}packages`)
      .then((res) => res.json())
      .then((data) => setPackages(data.data.data))
      .catch(() => setPackages([]));
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        setForm((prev) => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(files[0]);
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch(`${BaseUrl}vendor/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("Registration successful! Check your email to verify.");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        setMessage(data.message || "Registration failed.");
      }
    } catch (err) {
      setMessage("An error occurred.");
    }
    setLoading(false);
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light" style={{
      background: 'linear-gradient(135deg, #eca0a0ff 0%, #fff7ed 40%, #ffffff 100%)'
    }}>

        <style>
          {`
          .glass {
            backdrop-filter: blur(12px);
            background: rgba(255, 255, 255, 0.7);
            box-shadow: 0 10px 20px rgba(0,0,0,0.07);
            border: 1px solid rgba(255,255,255,0.3);
          }
          .login-shadow {
            box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
          }
        `}
        </style>
      <div className="card shadow-lg w-100" style={{ maxWidth: "1000px" }}>
        <div className="card-body p-4">
          <h3 className="card-title text-center mb-4">Register</h3>
          {message && (
            <div className="alert alert-danger text-center">{message}</div>
          )}
          <form onSubmit={handleSubmit}>
            {/* Full Name */}
            <div className="mb-3">
              <label className="form-label fw-bold">Full Name</label>
              <input
                type="text"
                name="full_name"
                value={form.full_name}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            {/* Package id */}
            {/* <div className="mb-3">
              <label className="form-label fw-bold">Package</label>
              <select
                name="package_id"
                value={form.package_id || package_id || ""}
                onChange={handleChange}
                required
                className="form-select"
              >
                <option value="">Select Package</option>
                {packages.map((c) => (
                  <option
                    key={c.id}
                    value={c.id}
                    selected={package_id === c.id}
                  >
                    {c.title}
                  </option>
                ))}
              </select>
            </div> */}
            {/* Business Name & Business Name (Ar) */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-bold">Business Name</label>
                <input
                  type="text"
                  name="business_name"
                  value={form.business_name}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Business Name (Ar)</label>
                <input
                  type="text"
                  name="business_name_ar"
                  value={form.business_name_ar}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
            </div>
            {/* Email & Phone Number with Country */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-bold">Email address</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Phone Number</label>
                <div className="input-group">
                  <select
                    name="country_id"
                    value={form.country_id}
                    onChange={handleChange}
                    required
                    className="form-select"
                    style={{ maxWidth: 150, height: "48px"  }}
                  >
                    <option value="">Country Code</option>
                    {countries.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.title} ({c.phone_code})
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    name="phone_number"
                    value={form.phone_number}
                    onChange={handleChange}
                    required
                    placeholder="Phone Number"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            {/* Password & Confirm Password */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-bold">Password</label>
                <input
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Confirm Password</label>
                <input
                  type="password"
                  name="password_confirmation"
                  value={form.password_confirmation}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
            </div>
            {/* Logo & Profile Image */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-bold">Logo</label>
                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={handleChange}
                  className="form-control"
                />
                {form.logo && (
                  <img src={form.logo} alt="Logo Preview" className="mt-2 rounded" style={{ height: "48px" }} />
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Profile Image</label>
                <input
                  type="file"
                  name="profile_image"
                  accept="image/*"
                  onChange={handleChange}
                  className="form-control"
                />
                {form.profile_image && (
                  <img src={form.profile_image} alt="Profile Preview" className="mt-2 rounded" style={{ height: "48px" }} />
                )}
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-common w-100 fw-bold"
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>
          <div className="mt-3 text-center">
            Already have an account? <a href="/login" className="text-warning text-decoration-underline">Login</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
